import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Element, Item } from '@outdoria/types';
import { fetcher } from '../utils';
import { ADMIN_ITEM_CREATE, ADMIN_ITEMS_ALL, ITEM } from '../queryKeys';

type Data = {
  item: Omit<Item, 'item_id'>;
  elements: Element['element_id'][];
};
export const useAdminCreateItem = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({
    item,
    elements,
  }: Data): Promise<{ item_id: string | null }> => {
    const response = await fetcher(`/v2/admin/items`, {
      method: 'POST',
      body: JSON.stringify({ ...item, elements }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (response.status !== 201)
      throw new Error((await response.json()).error ?? 'Did not work!');

    queryClient.invalidateQueries({ queryKey: ADMIN_ITEMS_ALL });
    queryClient.invalidateQueries({ queryKey: ITEM, exact: false });

    const res = await response.json();
    return res?.[0] ?? { item_id: null };
  };

  const { data, mutate, error, status, isPending, isSuccess, isError } =
    useMutation({
      mutationKey: ADMIN_ITEM_CREATE,
      mutationFn,
    });

  return { data, mutate, error, status, isPending, isSuccess, isError };
};
